export default "__VITE_ASSET__cfcdb934__"